<app-iframe-wrapper style="display: none"></app-iframe-wrapper>

@if (!shouldHideWaitMessage()) {
  <is-wait-message [useBolt]="false" [loadComplete]="canLoadApplication()" [waitMessage]="'Please wait while we process your request.'" [timeoutAmount]="0"></is-wait-message>
}

@if (canLoadApplication()) {
  <div class="global-container" id="global-container">
    <div class="outer-container" autoscroll="true">
      <router-outlet></router-outlet>
    </div>
    @if (isLoadedByBAM() !== true) {
      <is-footer [footerData]="footer()"></is-footer>
    }
  </div>
}
